import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FireEvent, TableAlign, TableTextButton} from '../../../../../../global';
import { NgIf } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { ButtonIconComponent } from '../../../../buttons/button-icon/button-icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-table-text-button',
    templateUrl: './table-text-button.component.html',
    imports: [NgIf, MatTooltip, ButtonIconComponent, TranslatePipe]
})
export class TableTextButtonComponent {

  @Input() public data: TableTextButton = null;

  @Input() align: TableAlign = TableAlign.CENTER;
  @Input() tooltip: string = null;
  @Input() textColor: string = null;

  @Output()
  public fireEvent = new EventEmitter<FireEvent>();
}
